import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { OrganizationService, SiteMembershipService } from '@se-po/shared-data-access-services'
import { forkJoin, Observable, of } from 'rxjs'
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators'

export const OPEN_REGISTRATION_FEATURE_TOGGLE_KEY = 'open_registration'

@Component({
  selector: 'app-registration-list-route',
  templateUrl: './registration-list-route.component.html',
  styleUrls: ['./registration-list-route.component.scss']
})
export class RegistrationListRouteComponent {
  public organizationIds: number[] = []
  public showOpenRegistration$: Observable<boolean | null>

  constructor(
    private activatedRoute: ActivatedRoute,
    private organizationService: OrganizationService,
    private siteMembershipService: SiteMembershipService
  ) {
    this.showOpenRegistration$ = this.getOrganizationIds().pipe(
      switchMap(organizationIds => {
        if (!organizationIds.length) return of(false)

        return forkJoin(organizationIds.map(organizationId => this.organizationService.hasFeatureToggleEnabled(
          organizationId.toString(),
          OPEN_REGISTRATION_FEATURE_TOGGLE_KEY
        ).pipe(
          catchError(() => of(false))
        ))).pipe(
          map(results => results.some(Boolean))
        )
      }),
      catchError(() => of(false)),
      startWith(null)
    )
  }

  private getOrganizationIds(): Observable<number[]> {
    const personaId = this.getPersonaId()    
    if (!personaId) return of([])
      
    return this.siteMembershipService.findAll(personaId).pipe(
      map(siteMemberships => siteMemberships.map(siteMembership => siteMembership.organization_id)),
      tap(organizationIds => this.organizationIds = organizationIds)
    )
  }

  private getPersonaId(): string | number | undefined {
    const routeData = this.activatedRoute.snapshot.data
    console.log('routeData', routeData)
    return routeData.personaSelf?.id || routeData.userProfiles?.user?.self_persona?.id
  }
}
